/**
 * 通用频道id('#': 代表非私密频道用户信息共用)
 */
export const COMMON_CHANNEL_ID = '#';
